let teamElements = [
    {
        name: "Cesar Cunha Pacheco",
        position: "Assistant Professor and Department Head",
        researchInterests: "Inverse problems, artificial intelligence, bioheat transfer",
        email: "mailto:cesarp@id.uff.br",
        lattes: "http://lattes.cnpq.br/4977724521165246",
        linkedin: "https://www.linkedin.com/in/cesarp-uff/",
        scopus: "https://www.scopus.com/authid/detail.uri?authorId=56694119600",
        orcid: "https://orcid.org/0000-0003-4935-8655",
        photo: require("../images/cesarpacheco.png"),
    },
    {
        name: "Isabela Florindo Pinheiro",
        position: "Assistant Professor",
        researchInterests: "Hybrid analytical-numerical methods, gasification, hydrogen, refrigeration, microfluidics",
        email: "mailto:isabelaflorindo@id.uff.br",
        lattes: "http://lattes.cnpq.br/4244258573417514",
        linkedin: "https://www.linkedin.com/in/isabela-florindo-5a4a2555/",
        scopus: "https://www.scopus.com/authid/detail.uri?authorId=57200374882",
        orcid: "https://orcid.org/0000-0002-2954-1869",
        photo: require("../images/isabelaflorindo.png"),
    },
    {
        name: "Kleber Marques Lisboa",
        position: "Assistant Professor",
        researchInterests: "Electrochemical cells, hydrogen, membrane distillation, microfluidics, hybrid analytical-numerical methods",
        email: "mailto:kmlisboa@id.uff.br",
        lattes: "http://lattes.cnpq.br/3734240256988290",
        linkedin: "https://br.linkedin.com/in/kleber-marques-lisboa-401270b0",
        scopus: "https://www.scopus.com/authid/detail.uri?authorId=56473617600",
        orcid: "https://orcid.org/0000-0003-0736-5996",
        photo: require("../images/kleberlisboa.png"),
    },
    {
        name: "Leandro Alcoforado Sphaier",
        position: "Associate Professor and Head of Latermo",
        researchInterests: "Adsorption, gasification, alcoholic fermentation, hybrid analytical-numerical methods",
        email: "mailto:lasphaier@id.uff.br",
        lattes: "http://lattes.cnpq.br/8948736724490274",
        linkedin: "https://www.linkedin.com/in/leandro-sphaier-a229212a/?originalSubdomain=br",
        scopus: "https://www.scopus.com/authid/detail.uri?authorId=6506755450",
        orcid: "https://orcid.org/0000-0003-3698-1077",
        photo: require("../images/leandrosphaier.png"),
    }
]

export default teamElements;